import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './AircraftOverview.module.scss';
import { PresentBlock1440pxType } from '@/types/aircraftOverview.types';

const AircraftOverview: NextPage<PresentBlock1440pxType> = ({
  className = '',
  image,
  text,
  items,
}) => {
  return (
    <section className="container">
      <div className={[styles.presentblock1440px, className].join(' ')}>
        <div className={styles.presentblock}>
          <Image
            className={styles.imgcontainerIcon}
            loading="lazy"
            width={855}
            height={274.6}
            sizes="100vw"
            alt=""
            src={image}
          />
          <div className={styles.textcontainer}>
            <div className={styles.text}>
              <p className={styles.weAlsoWork}>{text}</p>
              <p className={styles.weAlsoWork}>&nbsp;</p>
              {items ? (
                <>
                  <p className={styles.weAlsoWork}>{items.itemsTitle}</p>
                  <ul className={styles.reviewOfAircraftRequirement}>
                    {items.items?.map((item) => (
                      <li key={item.id}>{item.itemText}</li>
                    ))}
                  </ul>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AircraftOverview;
